import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { campaignsService, Campaign, CreateCampaignRequest } from '@aslanpay/portal-common-lib';

const useCreateCampaign = ({
  onSuccess,
  onError,
}: UseMutationOptions<Campaign, Error, CreateCampaignRequest>) => {
  return useMutation<Campaign, Error, CreateCampaignRequest>(
    (request) => campaignsService.createCampaign(request),
    { onSuccess, onError }
  );
};

export default useCreateCampaign;
